import React, { useRef, useImperativeHandle, forwardRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';

const SignaturePad = forwardRef(({ onEnd }, ref) => {
  const sigRef = useRef(null);

  useImperativeHandle(ref, () => ({
    getDataURL: () => sigRef.current?.toDataURL('image/png') || null,
    clear: () => sigRef.current?.clear(),
    isEmpty: () => sigRef.current?.isEmpty() ?? true,
  }));

  return (
    <div className="border-2 border-dashed border-slate-200 rounded-2xl overflow-hidden bg-white hover:border-sky-400 transition-colors">
      <SignatureCanvas
        ref={sigRef}
        penColor="#0f172a"
        canvasProps={{ width: 500, height: 180, className: 'w-full' }}
        onEnd={onEnd}
      />
    </div>
  );
});

SignaturePad.displayName = 'SignaturePad';
export default SignaturePad;
